import { useEffect } from "react";
import { Link, createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RequireAuth } from "@/components/RequireAuth";
import { AppShell } from "@/components/layout/AppShell";
import { SettlementForm } from "@/components/payroll/SettlementForm";
import { useActiveCompany } from "@/lib/company-context";

export const Route = createFileRoute(
  "/companies/$companyId/nomina/definitivas/new",
)({
  component: NewSettlementPage,
});

function NewSettlementPage() {
  return (
    <RequireAuth>
      <AppShell>
        <NewSettlementContent />
      </AppShell>
    </RequireAuth>
  );
}

function NewSettlementContent() {
  const { t } = useTranslation();
  const { companyId } = Route.useParams();
  const { setActiveCompanyId } = useActiveCompany();

  useEffect(() => {
    if (companyId) setActiveCompanyId(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-6">
      <div>
        <Link
          to="/companies/$companyId/nomina/definitivas"
          params={{ companyId }}
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-3 w-3" />
          {t("settlements.new.back")}
        </Link>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight">
          {t("settlements.new.title")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("settlements.new.subtitle")}
        </p>
      </div>
      <SettlementForm companyId={companyId} />
    </div>
  );
}
